import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig, RoutingModule, UrlModule } from '@spartacus/core';
import { CarouselModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CartSharedModule } from '../../cart/cart-shared/cart-shared.module';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { ShimanoProductReferencesComponent } from './shimano-product-references.component';

@NgModule({
  declarations: [ShimanoProductReferencesComponent],
  imports: [
    CommonModule,
    CartSharedModule,
    OutletModule,
    I18nModule,
    RouterModule,
    CarouselModule,
    MediaModule,
    RoutingModule,
    UrlModule,
    SlickCarouselModule,
    MatIconModule,
    TooltipIconModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReferencesComponent: {
          component: ShimanoProductReferencesComponent,
        },
      },
    }),
  ],
  exports: [ShimanoProductReferencesComponent],
})
export class ShimanoProductReferencesModule {}
